export default {"src":"/_next/static/media/steps_black.91ac40c5.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};